import {UIGameChat} from './UIGameChat/UIGameChat'
import {UIGameLog} from './UIGameLog/UIGameLog'
import React, {useMemo, useState} from 'react'
import styles from './UIGameFeeds.module.scss'
import {UIMutePlayerProvider} from '../../contexts/UIMutePlayerContext'
import {useUIGameStateContext} from '../../contexts/UIGameStateContext'
import {useUIGameUserStatesContext} from '../../contexts/UIGameUserStatesContext'
import {cloneDeep} from 'lodash-es'
import {GameValidator} from '@colonist/game-mechanic-validators'
import clsx from 'clsx'
import {UIGameVoteContainer} from '../UIGameVote/UIGameVoteContainer'

export interface UIGameFeedsProps {
    isChatEnabled: boolean
    onClickLog: (logIndex: number) => void
    onSendChat: (message: string) => void
    isChatDefaultMinimized?: boolean
    className?: string
}

export function UIGameFeeds({
    isChatEnabled,
    onClickLog,
    onSendChat,
    isChatDefaultMinimized,
    className,
}: UIGameFeedsProps) {
    const {gameState} = useUIGameStateContext()
    const {userStates} = useUIGameUserStatesContext()
    const [isLogVisible, setIsLogVisible] = useState(true)
    const [isChatVisible, setIsChatVisible] = useState(true)

    const gameValidator = useMemo(() => {
        const clonedGameState = cloneDeep(gameState)
        for(const playerColorKey in clonedGameState.playerStates) {
            clonedGameState.playerStates[playerColorKey].isConnected = true
        }

        return new GameValidator(gameState, userStates)
    }, [])

    return (
        <UIMutePlayerProvider>
            <div className={clsx(styles.responsiveContainer, className)}>
                <UIGameVoteContainer
                    className={styles.gameVoteContainer}
                    setLogVisible={setIsLogVisible}
                    setChatVisible={setIsChatVisible}/>
                <UIGameLog gameValidator={gameValidator} onClickLog={onClickLog} isLogVisible={isLogVisible} />
                {isChatEnabled && <UIGameChat
                    gameValidator={gameValidator}
                    isChatVisible={isChatVisible}
                    isDefaultMinimized={isChatDefaultMinimized}
                    onSendChat={onSendChat}/>}
            </div>
        </UIMutePlayerProvider>
    )
}
